// A login page returns the person to the page that sent them there (?redirect=, set by the route
// guards in components/authority/RoleRoute). The value comes from the URL, so only a path of this
// site is followed: it must start with "/" and not with "//" or "/\\", which a browser reads as
// another host. Anything else is ignored and the caller falls back to its default page.
export const safeRedirect = (value) => (
  typeof value === 'string' && value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/\\')
    ? value
    : undefined
);
